// removed by extract-text-webpack-plugin
module.exports = {"container":"_30id7","error":"_3SjIf","icon":"_3fwJQ","title":"_2CC5f","inputWrapper":"_6SxH9","input":"jgkVD","border":"_39pls"};


//////////////////
// WEBPACK FOOTER
// ./app/components/text-editor-video-embed-form/text-editor-video-embed-form.scss
// module id = 957
// module chunks = 3 4 5 6 7